module.exports = __webpack_public_path__ + "media/images/down_arrow-39b2b346e4013fa88aba82b93901e4ed.svg";